import { Component } from "react";
import TableNew, { CELL_TYPES } from "../../../../shared/Table";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

import JSONTree from "react-json-tree";

class EventTableDetails extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          <h4> Additional info </h4>
          <JSONTree hideRoot={true} data={this.props.item["Item2"]} />
        </div>
      </div>
    );
  }
}

class EventTableComponent extends Component {
  constructor(props) {
    super(props);

    let columns = [
      { key: "Id", label: "Stream key", visible: true, type: CELL_TYPES.text },
      {
        key: "Item2.Id",
        label: "Event Id",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "SequenceNumber",
        label: "Sequence number",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "Item1",
        label: "Event name",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "TimeStamp",
        label: "Time stamp",
        visible: true,
        type: CELL_TYPES.date,
      },
    ];

    this.state = { columns, key: "" };
  }

  searchClick = () => {
    this.props.getEventsByKey(this.state.key);
    this.props.changeEventByKeyListPage(1);
  };

  setKey = (event) => {
    this.setState({
      key: event.target.value,
    });
  };

  render() {
    return (
      <div className="applications-layout body-height content-padding">
        <h3>Event list by key table:</h3>
        <div className="row">
          <div className="col-md-6">
            <TextField
              size="small"
              variant="outlined"
              value={this.state.key}
              onChange={this.setKey}
              label="Stream key"
            />
          </div>
          <div className="col-md-6">
            <Button
              variant="outlined"
              color="primary"
              keyboardFocused={false}
              onClick={this.searchClick}
            >
              Search
            </Button>
          </div>
        </div>
        {!this.props.browser.eventsByKey.fetched ? (
          <div> Loading... </div>
        ) : (
          <TableNew
            columns={this.state.columns}
            items={this.props.browser.eventsByKey.data}
            tableKey="BrowserEventByKeyBrowserTable"
            showDetails={true}
            detailsRenderer={(item) => {
              return <EventTableDetails item={item} />;
            }}
          />
        )}
      </div>
    );
  }
}
export default EventTableComponent;
